<div class="modal-header" [ngClass]="{ 'dark-mode-modal': darkMode }">
  <div class="modal-header--title">
    <ng-content select="sim-icon" />
    <h4 class="modal-header--title--text" *ngIf="headerTitle">{{ headerTitle }}</h4>
  </div>
  <ng-content />
</div>
